(() => {
    require('../es6.polyfills');
    require('../vendors.js');
    require('framework/desktop.ui');
    $.getScript(require('../get_setup_url'), () => {
        require('../requirejs.proxy');
        require('../desktop.flights.jsx');
        require('../desktop.hotels');
    });
})();
